import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom';
import { setSelectedBlog } from '../../store/reducer/blogReducer';
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1';
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader';
import ProductPagination from '../../Componet/ProductPagination';
import { getBlogPath, getBlogTitle } from '../../utils/blog';

function BlogStyle() {
    const location = useLocation();
    const isHebrewBlog = location.pathname.startsWith('/he/');
    const blogs = useSelector((state) => state.blog.blogItems);
    const dispatch = useDispatch()
    const [activePage, setActivePage] = useState(1);
    const pageSize = 10; // change here to add more Blog posts

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
    };
    const totalPages = Math.ceil(blogs.length / pageSize);

    const startIndex = (activePage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const blogsToShow = blogs.slice(startIndex, endIndex);
    return (
        <>
            <HerosectionHeader
                folder1={"pages"}
                folder2={"Blog"}
                name={isHebrewBlog ? "מאמרים ומדריכים" : "Technical documentation"}
            />
            <div class="page-content">
                <section>
                    <div className="container">
                        {isHebrewBlog && (
                            <div className="row mb-5" dir="rtl">
                                <div className="col-12">
                                    <div className="bg-primary text-white rounded shadow p-4 p-lg-5 d-lg-flex align-items-center justify-content-between gap-4">
                                        <div>
                                            <h2 className="h3 text-white mb-2">מרכז הידע הראשי של EpicFinal</h2>
                                            <p className="mb-0">למאמרים, מדריכים ועדכונים חדשים בקרו במרכז הידע הראשי שלנו.</p>
                                        </div>
                                        <a
                                            href="https://blog.epicfinal.com/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-light flex-shrink-0 mt-3 mt-lg-0"
                                        >
                                            למרכז הידע הראשי
                                            <i className="las la-external-link-alt me-2" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="row">
                            {blogsToShow.map((blog) => (
                                <div className="col-md-6 col-lg-4 mb-5 mb-lg-0" key={blog.id}>
                                    <div className="card border-0 shadow bg-transparent">
                                        <img
                                            className="card-img-top"
                                            src={require(`../../assets/images/blog/${blog.image.split('/')[3]}`)}
                                            alt="Image1"
                                        />

                                        <div className="card-body p-4">
                                            <div>
                                                <div className="d-inline-block bg-light text-center px-2 py-1 rounded me-2">
                                                    <span className="text-primary">{blog.date}</span>
                                                </div>
                                                <Link to={getBlogPath(blog, location.pathname)} onClick={() => { dispatch(setSelectedBlog(blog.id)) }} className="d-inline-block btn-link">
                                                    {blog.category}
                                                </Link>
                                            </div>
                                            <h2 className="h5 my-3">
                                                <Link to={getBlogPath(blog, location.pathname)} className="link-title" dir="auto" style={{ unicodeBidi: 'plaintext' }} onClick={() => { dispatch(setSelectedBlog(blog.id)) }} >
                                                    {getBlogTitle(blog, location.pathname)}
                                                </Link>
                                            </h2>
                                            <ul className="list-inline mb-0">
                                                <li className="list-inline-item pe-3">
                                                    <Link to="/" className="list-group-item-action">
                                                        <i className="lar la-user-circle me-1 text-primary ic-1x"></i> {blog.author}
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item pe-3">
                                                    <Link to="/" className="list-group-item-action">
                                                        <i className="las la-eye me-1 text-primary ic-1x"></i> {blog.views}
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item">
                                                    <Link to="/" className="list-group-item-action">
                                                        <i className="lar la-comments me-1 text-primary ic-1x"></i> {blog.comments}
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div class="row mt-6">
                            <div class="col-12">
                                <ProductPagination
                                    activePage={activePage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <NewsletterL1 />
            </div>

        </>
    )
}

export default BlogStyle
